import { useQuery } from '@tanstack/react-query';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import { API } from '@src/api/api.ts';

export const useAuthorsQuery = () => {
  const { moduleId } = useModuleByCodeParam();
  return useQuery({
    queryFn: async () => await API.users.getAuthors({ module: moduleId }),
    queryKey: ['authors', moduleId],
    initialData: [],
    enabled: typeof moduleId !== 'undefined',
  });
};
